import React, { useState } from "react";
const FAQComponent = ({ faq, isOpen, onToggle }) => {
    return (
      <div className="dropdownfilter w-full bg-[#f5f5f5] py-6 px-8 rounded-lg mb-3 last:mb-0">
        <button
          className="w-full flex justify-between items-center"
          onClick={onToggle}
          aria-expanded={isOpen}
        >
          <span className="text-xl text-start font-semibold text-dark w-[calc(100%-30px)]">
            {faq?.question}
          </span>
          <svg
            className={`dropdown-arrow transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"}`}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.636 13.828L19.1308 6.33337L21.2721 8.47471L11.636 18.1108L2 8.47471L4.14134 6.33337L11.636 13.828Z"
              fill="black"
            />
          </svg>
        </button>
        {isOpen && (
          <div className="mt-4 space-y-2 dropdownContentfilter">
            <p className="text-justify font-medium text-dark text-base">
              {faq?.answer}
            </p>
          </div>
        )}
      </div>
    );
  };
  
export default FAQComponent;
